<section class="pt-3">
  <h2 class="user-select-none">Tables</h2>
  <p class="user-select-none">Drag and drop objects on the canvas. You may change the actual size of the object and rotate it once placed.</p>

  <div class="tables">
    <div class="floorplan-table background-hover" *ngFor="let table of tables">
      <div
        class="user-select-none"
        [ngClass]="['item border-shape-border drag-table', table.shape, table.size, disabled ? 'disabled' : 'background-shape']"
        (mousedown)="dragElement($event, table.shape, table.size)"
        (touchstart)="dragElement($event, table.shape, table.size)"
      >
        <p class="color-shape-text user-select-none">{{ sizeText[table.size] }}</p>
      </div>
    </div>
  </div>
</section>
